define('modules/estimate_status/Model',['require','exports','module','lib/console','app','backbone'],function(require, exports, module) {
    "use strict";

    var logger = require('lib/console');
    var app = require('app');
    //var BaseModel = require('doctrine/model/EstimateStatusBase');

    var Backbone = require("backbone");

    //var Model = BaseModel.extend({

    var Model = Backbone.Model.extend({

        //idAttribute: 'estimateStatusId',

        url: function() {

            if (this.isNew()) {
                return app.api + 'estimate_status';
            }
            return app.api + 'estimate_status/' + this.getId();

        },

        initialize: function() {

        },

        getId: function() {
            return this.get(this.idAttribute);
        },

        getLabel: function() {
            return this.get(this.idAttribute);
        },

        validate: function(attrs, options) {

        }

    });

    module.exports = Model;
});
